import React from 'react';
import ContactForm from '../components/contacts/ContactForm';
import ContactCard from '../components/contacts/ContactCard';
import Breadcrumb from '../components/layout/Breadcrumb';
import Seo from '../components/Seo';

const ContactPage = () => {
  return (
    <div className="w-full overflow-x-hidden">
      <Seo
        title="Contact Us | PVS Harness Solution"
        description="Get in touch with PVS Harness Solution for custom wire harness manufacturing inquiries, quotes, and support."
        path="/contact"
        schema={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://pvsharness.com/" },
            { "@type": "ListItem", "position": 2, "name": "Contact Us", "item": "https://pvsharness.com/contact" }
          ]
        }}
      />

      <Breadcrumb
        heading="Lets Connect"
        links={[
          { label: "Home", url: "/" },
          { label: "Contact Us" }
        ]}
      />

      <section className="py-10 sm:py-14 lg:py-20">
        <ContactCard />
      </section>

      <section className="pb-16 sm:pb-20 lg:pb-24">
        <ContactForm />
      </section>
    </div>
  );
};

export default ContactPage;